export enum OutrightMode {
    Once = "once",
    Three = "3x",
    Four = "4x",
    Holiday = "holiday"
}